// Hooks
import { useAppDispatch, useAppSelector } from '../../../app/hooks';

// Features
import {
    selectModalContent,
    clearModalContent,
} from '../../../features/app/appSlice';
import ModalContentHandler from '../../molecules/ModalContent/ModalContentHandler';

// Styles
import styles from './Modal.module.css';

/**
 * @function Modal
 * Describe the component's function
 *
 * @example
 * return (
 *   <Modal />
 * )
 */
function Modal(): JSX.Element {
    const dispatch = useAppDispatch();
    const modalContent = useAppSelector(selectModalContent);

    function handleCloseClick() {
        dispatch(clearModalContent());
    }

    return (
        <div className={styles.container}>
            <div className={styles.dialog}>
                <button
                    type="button"
                    className={styles.close}
                    onClick={() => handleCloseClick()}
                >
                    <span>Close</span> ×
                </button>
                <ModalContentHandler name={modalContent} />
            </div>
        </div>
    );
}

// Exports
export default Modal;
